export default "__VITE_ASSET__ByNkrjcT__"